import { colorForTechnician, initials } from '../utils/technicianColor';

interface TechnicianAvatarProps {
  id: string;
  name: string;
  size?: number;
}

// Цветной кружок с инициалами — тот же цвет на карте (точка), в ростере мастеров и в чате,
// т.к. все три места используют один и тот же colorForTechnician(id)
export default function TechnicianAvatar({ id, name, size = 32 }: TechnicianAvatarProps) {
  return (
    <div
      className="technician-avatar"
      style={{ background: colorForTechnician(id), width: size, height: size, fontSize: size * 0.4 }}
    >
      {initials(name)}
    </div>
  );
}
